import { Flex } from "@jsq/ds/core";
import { skeletonEffect, skeletonLoaderCellContainer } from "./styles_vanilla.css";

export const SkeletonLoaderCell = () => {
  return (
    <Flex alignItems="center" className={skeletonLoaderCellContainer}>
      <div className={skeletonEffect} />
    </Flex>
  );
};
